import React from 'react'

function UpdatePRServiceCategoriesPage() {
  return <div className="page-container">update pr service categories</div>;
}

export default UpdatePRServiceCategoriesPage
